import React from 'react';

import Reservation from './Reservation';

const ReservationWrapper = (props) => <Reservation {...props} />

export default ReservationWrapper;